import { i18n } from "@/resources/locales";

export enum MANAGE_TYPE_OPTIONS {
  CAMPUS,
  SPACE,
}

export enum MANAGE_SPACE_OPTIONS {
  MANAGE = "MANAGE",
  INVITE = "INVITE",
  PENDING = "PENDING",
  CUSTOMIZE = "CUSTOMIZE",
  ROOMS = "ROOMS",
  SETTINGS = "SETTINGS",
  MULTI_SPACE_CUSTOMIZE = "MULTI_SPACE_CUSTOMIZE",
  MULTI_SPACE_CONFIGURATION = "MULTI_SPACE_CONFIGURATION",
  MULTI_SPACE_SETTING = "MULTI_SPACE_SETTING",
  LOGS = "LOGS",
  POSTERS = "POSTERS",
}

export enum PROFILE_SIDEBAR_OPTIONS {
  GENERAL = "GENERAL",
  SECURITY = "SECURITY",
  AVATAR = "AVATAR",
  SOCIAL = "SOCIAL",
  LOGS = "LOGS",
  PET = "PET",
  VIDEO_AUDIO = "VIDEO_AUDIO",
  CV = "CV",
  CURRICULUM = "CURRICULUM"
}

export enum ADMIN_SIDEBAR_OPTIONS {
  DASHBOARD = "DASHBOARD",
  DASHBOARD_SP = "DASHBOARD_SP",
  USERS_SP = "USERS_SP",
  SPACE = "SPACE",
  REQUEST_SPACE = "REQUEST_SPACE",
  USERS = "USERS",
  ANNOUNCEMENTS = "ANNOUNCEMENTS",
  USERS_GROUP = "USERS_GROUP",
}

export const MANAGE_SPACE_SIDEBAR = [
  {
    label: i18n.t("manageSpaces.sidebar.customizeSpace"),
    icon: "fas fa-paint-roller",
    id: MANAGE_SPACE_OPTIONS.CUSTOMIZE,
  },
  {
    label: i18n.t("manageSpaces.sidebar.customizeMultiSpace"),
    icon: "fas fa-paint-roller",
    id: MANAGE_SPACE_OPTIONS.MULTI_SPACE_CUSTOMIZE,
  },
  {
    label: i18n.t("admin.sidebar.analytics"),
    icon: "fas fa-chart-area",
    id: ADMIN_SIDEBAR_OPTIONS.DASHBOARD_SP,
  },
  {
    label: i18n.t("manageSpaces.sidebar.settingsMultiSpace"),
    icon: "fas fa-cog",
    id: MANAGE_SPACE_OPTIONS.MULTI_SPACE_CONFIGURATION,
  },
  {
    label: i18n.t("admin.sidebar.analytics"),
    icon: "fas fa-chart-area",
    id: ADMIN_SIDEBAR_OPTIONS.DASHBOARD,
  },
  {
    label: i18n.t("manageSpaces.sidebar.customizeRooms"),
    icon: "fas fa-door-closed",
    id: MANAGE_SPACE_OPTIONS.ROOMS,
  },
  {
    label: i18n.t("manageSpaces.sidebar.posters"),
    icon: "fas fa-image",
    id: MANAGE_SPACE_OPTIONS.POSTERS,
  },
  {
    label: i18n.t("manageSpaces.sidebar.spaceSettings"),
    icon: "fas fa-cog",
    id: MANAGE_SPACE_OPTIONS.SETTINGS,
  },
  {
    label: i18n.t("manageSpaces.sidebar.manageUsersSuperSpace"),
    icon: "fas fa-user-cog",
    id: ADMIN_SIDEBAR_OPTIONS.USERS_SP,
  },
  {
    label: i18n.t("buttons.usersGroup"),
    icon: "fas fa-users",
    id: ADMIN_SIDEBAR_OPTIONS.USERS_GROUP,
  },
  {
    label: i18n.t("manageSpaces.sidebar.manageUsers"),
    icon: "fas fa-user-cog",
    id: MANAGE_SPACE_OPTIONS.MANAGE,
  },
  {
    label: i18n.t("profile.sidebar.logs"),
    icon: "fas fa-clipboard",
    id: PROFILE_SIDEBAR_OPTIONS.LOGS,
    guest: false,
    onBoarding: false,
  },
  {
    label: i18n.t("manageSpaces.sidebar.inviteUsers"),
    icon: "fas fa-user-plus",
    id: MANAGE_SPACE_OPTIONS.INVITE,
  },
  {
    label: i18n.t("buttons.programNotification"),
    icon: "fas fa-paper-plane",
    id: ADMIN_SIDEBAR_OPTIONS.ANNOUNCEMENTS,
  },
  {
    label: i18n.t("manageSpaces.sidebar.campusSpaces"),
    icon: "fas fa-building",
    id: MANAGE_SPACE_OPTIONS.MULTI_SPACE_SETTING,
  },
];

export const MANAGE_SPACE_IN_SUPER_SPACE_SIDEBAR = [
  {
    label: i18n.t("manageSpaces.sidebar.customizeSpace"),
    icon: "fas fa-paint-roller",
    id: MANAGE_SPACE_OPTIONS.CUSTOMIZE,
  },
  {
    label: i18n.t("admin.sidebar.analytics"),
    icon: "fas fa-chart-area",
    id: ADMIN_SIDEBAR_OPTIONS.DASHBOARD,
  },
  {
    label: i18n.t("manageSpaces.sidebar.customizeRooms"),
    icon: "fas fa-door-closed",
    id: MANAGE_SPACE_OPTIONS.ROOMS,
  },
  {
    label: i18n.t("manageSpaces.sidebar.posters"),
    icon: "fas fa-image",
    id: MANAGE_SPACE_OPTIONS.POSTERS,
  },
  {
    label: i18n.t("manageSpaces.sidebar.spaceSettings"),
    icon: "fas fa-cog",
    id: MANAGE_SPACE_OPTIONS.SETTINGS,
  },
  {
    label: i18n.t("manageSpaces.sidebar.manageUsers"),
    icon: "fas fa-user-cog",
    id: MANAGE_SPACE_OPTIONS.MANAGE,
  },
  {
    label: i18n.t("profile.sidebar.logs"),
    icon: "fas fa-clipboard",
    id: PROFILE_SIDEBAR_OPTIONS.LOGS,
    guest: false,
    onBoarding: false,
  },
  {
    label: i18n.t("manageSpaces.sidebar.inviteUsers"),
    icon: "fas fa-user-plus",
    id: MANAGE_SPACE_OPTIONS.INVITE,
  },
  {
    label: i18n.t("buttons.programNotification"),
    icon: "fas fa-paper-plane",
    id: ADMIN_SIDEBAR_OPTIONS.ANNOUNCEMENTS,
  },
];

export const MANAGE_SPACE_SIDEBAR_INVITE = [
  {
    label: i18n.t("manageSpaces.sidebar.inviteUsers"),
    icon: "fas fa-user-plus",
    id: MANAGE_SPACE_OPTIONS.INVITE,
  },
];

export const PROFILE_USER_SIDEBAR = [
  {
    label: i18n.t("profile.sidebar.general"),
    icon: "fas fa-user-cog",
    id: PROFILE_SIDEBAR_OPTIONS.GENERAL,
    guest: true,
    onBoarding: true,
  },
  {
    label: i18n.t("profile.sidebar.social"),
    icon: "fas fa-rss",
    id: PROFILE_SIDEBAR_OPTIONS.SOCIAL,
    guest: true,
    onBoarding: true,
  },
  {
    label: i18n.t("profile.sidebar.knowledge"),
    icon: "fas fa-file",
    id: PROFILE_SIDEBAR_OPTIONS.CV,
    guest: true,
    onBoarding: true,
  },
  {
    label: i18n.t("profile.sidebar.curriculum"),
    icon: "fas fa-graduation-cap",
    id: PROFILE_SIDEBAR_OPTIONS.CURRICULUM,
    guest: true,
    onBoarding: true,
  },
  {
    label: i18n.t("actions.avatar"),
    icon: "fas fa-user-tie",
    id: PROFILE_SIDEBAR_OPTIONS.AVATAR,
    guest: true,
    onBoarding: true,
  },
  {
    label: i18n.t("actions.pet"),
    icon: "fas fa-dog",
    id: PROFILE_SIDEBAR_OPTIONS.PET,
    guest: true,
    onBoarding: true,
  },
  {
    label: i18n.t("profile.sidebar.security"),
    icon: "fas fa-lock",
    id: PROFILE_SIDEBAR_OPTIONS.SECURITY,
    guest: false,
    onBoarding: false,
  },
  {
    label: i18n.t("profile.sidebar.logs"),
    icon: "fas fa-clipboard",
    id: PROFILE_SIDEBAR_OPTIONS.LOGS,
    guest: false,
    onBoarding: false,
  },
  {
    label: i18n.t("profile.sidebar.videoAudio"),
    icon: "fas fa-video",
    id: PROFILE_SIDEBAR_OPTIONS.VIDEO_AUDIO,
    guest: true,
    onBoarding: false,
  },
];

export const ADMIN_SIDEBAR_MENU = [
  {
    label: i18n.t("admin.sidebar.dashboard"),
    icon: "fas fa-home",
    id: ADMIN_SIDEBAR_OPTIONS.DASHBOARD,
    link: "dashboard",
  },
  {
    label: i18n.t("admin.sidebar.multi_spaces"),
    icon: "fas fa-building",
    id: ADMIN_SIDEBAR_OPTIONS.SPACE,
    link: "multi_spaces",
  },
  {
    label: i18n.t("admin.sidebar.spaces_requests"),
    icon: "fas fa-clipboard-list",
    id: ADMIN_SIDEBAR_OPTIONS.REQUEST_SPACE,
    link: "spaces_requests",
  },
];

export enum NUBII_SIDEBAR_OPTIONS {
  USERS,
  MESSAGE,
  TOOLKITS,
  HAWKING_TOOL,
  CONFIG,
  LIST_SUPER_SPACES,
  CHANGE_SPACE,
  OPEN_MUSIC,
  UTILITIES,
}
